function getApiUrl() {
    let apiUrl = "https://translation-dev.actidoo.com/api";

    if (process.env.REACT_APP_SERVER == "localhost") {
        apiUrl = "http://localhost:6543/api";
    } else if (process.env.REACT_APP_SERVER == "development") {
        apiUrl = "https://translation-dev.actidoo.com/api";
    } else if (process.env.REACT_APP_SERVER == "production") {
        apiUrl = "https://translation.actidoo.com/api";
    }

    return apiUrl;
}

module.exports = {
    getApiUrl: getApiUrl
};



// WEBPACK FOOTER //
// ./src/config.js